import { getActiveLoadProcess } from "../selectors/loader";

export const SET_LOADING_PROCESS = "SET_LOADING_PROCESS";

const setLoadingProcess = (process) => ({
  type: SET_LOADING_PROCESS,
  payload: process,
});

export const startLoadingProcess = (processId) => (dispatch, getState) => {
  const activeProcess = getActiveLoadProcess(getState());
  dispatch(setLoadingProcess([...new Set(activeProcess.concat(processId))]));
};

export const endLoadingProcess = (processId) => (dispatch, getState) => {
  const activeProcess = getActiveLoadProcess(getState());
  dispatch(
    setLoadingProcess(activeProcess.filter((process) => process !== processId))
  );
};
